import { commonMessages } from '../../../util/messages'

export const messages = {
  common: commonMessages,
  create: {
    success: 'Counterparty compliance rule successfully created',
    error: 'Error creating counterparty compliance rule',
  },
  update: {
    success: 'Counterparty compliance rule successfully updated',
    error: 'Error updating counterparty compliance rule',
  },
  delete: {
    success: 'Counterparty compliance rule successfully deleted',
    error: 'Error deleting counterparty compliance rule',
  },
}
